import { render, staticRenderFns } from "./weteacheManage.vue?vue&type=template&id=253b2d47&scoped=true&"
import script from "./weteacheManage.vue?vue&type=script&lang=js&"
export * from "./weteacheManage.vue?vue&type=script&lang=js&"
import style0 from "./weteacheManage.vue?vue&type=style&index=0&id=253b2d47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253b2d47",
  null
  
)

export default component.exports